import React from 'react';
import { Link } from 'react-router-dom';

const release2 = {
    idx: 1,
    date: '2025-03-31',
    title: 'LobbyIQ Announces Successful 2024 Growth Results',
    body: (
        <div className="flex flex-col gap-6">
            <p>
                Published on March 31st, 2025
                <br />
                London, Ontario
            </p>
            <p>
                LobbyIQ, an Ontario-based government relations technology start-up, announced rapid
                sales growth for 2024, the company's second year of operation.
            </p>
            <p>
                Sales grew by more than 500% in 2024, driven by the successful launch of new
                parliamentary monitoring and issue tracking product features. LobbyIQ's clients
                include Canada's leading corporations in a diverse set of sectors, from technology,
                energy, and agriculture, to higher education.
            </p>
            <p>
                “We are excited about LobbyI's growth trajectory for 2025 as more and more
                organizations are learning about how LobbyIQ can assist their government relations
                functions,” noted Guy Holburn, President and Co-Founder. “LobbyIQ's monitoring and
                AI technologies help busy GR professionals save significant amounts of time on
                routine tasks, freeing up time for advocacy and relationship-building”, according to
                Christian Dippel, CEO and Co-Founder.
            </p>
            <p>
                <b>About LobbyIQ</b>
                <br />
                <i>Critical Intelligence for Government Relations and Parliamentary Affairs</i>
            </p>
            <p>
                LobbyIQ helps organizations effortlessly navigate the complex landscape of
                government relations and parliamentary affairs through the power of AI-driven
                analytics. Track custom issues, monitor committees in real-time, and leverage
                dashboard insights.
            </p>
            <p>
                For more information, visit{' '}
                <Link
                    className="text-blue-400 font-medium hover:underline"
                    to="https://ca.lobbyiq.org/"
                >
                    www.ca.lobbyiq.org
                </Link>{' '}
                or email contact@lobbyiq.org
            </p>
        </div>
    ),
};

export default release2;
